import { FlagrKeys } from "@doopage-client-js/messenger";

export const STAFF_FLAGR_KEYS = [
    FlagrKeys.SALE_ENABLED,
    FlagrKeys.CHANNEL_PAYMENT_ENABLED,
];

export const DEFAULT_FLAGR_KEY_VALUE_MAP = {
    [FlagrKeys.SALE_ENABLED]: false,
    [FlagrKeys.CHANNEL_PAYMENT_ENABLED]: true,
};
